



















import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class DiceAttributeInput extends Vue {
  @Prop({ default: 0 })
  public dice!: number;

  @Prop()
  public label!: string;

  @Prop()
  public abbreviation!: string;

  @Prop({ default: 0 })
  public modifier!: number;

  public emitDice(value) {
    this.$emit('diceattribute:change', this.abbreviation, 'dice', value);
  }

  public emitModifier(value) {
    this.$emit('diceattribute:change', this.abbreviation, 'modifier', value);
  }
}
